import {FormInstance} from 'antd/es/form';
import {createContext} from 'react';

import {IValidationController} from 'components/editable-table/model/types';
import {TEntityValue} from 'modules/data';
import {TStateSetter} from 'shared/types/generics';

export type TEditableFormTable = {
    initData?: Record<string, TEntityValue>[];
    form?: FormInstance;
    setForm?: TStateSetter<FormInstance | undefined>;
    validation?: IValidationController;
    setValidation?: TStateSetter<IValidationController | undefined>;
}

const EditableFormTableInitState = {
    initData: [],
    form: undefined,
    setForm: undefined,
    validation: undefined,
    setValidation: undefined,
};

export const EditableFormTableContext = createContext<TEditableFormTable>(EditableFormTableInitState);
